import { getUserOrgPref, spError } from '@eventr/common'
import { StateCreator } from 'zustand'
import { DataAPI } from '../../data/Data'
import { useDeviceInfo } from '../../feat/appState/deviceInfo'
import {
    isCalendarEnabled,
    syncDeviceCalendar,
} from '../../feat/calendar/calendarProvider'
import { EventrCapacitorCalendar } from '../../feat/push/plugin'
import { BoundStore, bs } from '../bound.store'
import { syncing } from './calendarSignal'

interface CalendarState { }
interface CalendarActions {
    clearCalendars: () => void
    syncCalendar: (
        itinId?: number,
        cals?: string[],
        update?: boolean,
        reminder?: boolean
    ) => Promise<void>
}
export interface CalendarSlice extends CalendarState, CalendarActions { }

export const createCalendarSlice: StateCreator<
    BoundStore,
    [['zustand/devtools', never]],
    [],
    CalendarSlice
> = (set, get) => ({
    clearCalendars: async () => {
        try {
            if (
                isCalendarEnabled(useDeviceInfo.getState().version.buildVersion)
            ) {
                syncing.value = false
                let cals = getUserOrgPref(
                    'homepage',
                    `calendarSync`,
                    bs().selectedOrg?.name ?? ''
                )

                const allCalsResponse =
                    await EventrCapacitorCalendar.listCalendars()
                const allCals = allCalsResponse.result

                if (cals && cals.length > 0) {
                    if (!Array.isArray(cals)) {
                        cals = [cals]
                    }
                    cals?.forEach((element: string) => {
                        const parts = element.split(' - ')
                        const calendarId = parts[1]

                        const matchingCal = allCals?.find(
                            (cal) => cal?.id === calendarId
                        )

                        if (matchingCal) {
                            EventrCapacitorCalendar.deleteCalendar({
                                id: calendarId,
                            })
                        } else {
                            console.log(
                                `No matching calendar found for id: ${calendarId}`
                            )
                        }
                    })
                }
            }
        } catch (error) {
            spError('might be known issue of logout without org.', error)
        }
    },
    syncCalendar: async (itinId, cals, update, reminder) => {
        const { selectedOrg } = get()
        const itineraryIdToUse = itinId || get().selectedItinID

        if (itineraryIdToUse && get().selectedItinID) {
            try {
                const data = await DataAPI.getCalendar(itineraryIdToUse)
                await syncDeviceCalendar(
                    data,
                    selectedOrg?.name ?? 'defaultOrgName',
                    cals ?? [],
                    update,
                    reminder
                )
            } catch {
                spError(`Error retrieving calendar`)
            }
        }
    },
})
